import { GetServerSideProps } from 'next';
import { getProcessEnvs, PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { mockModel } from '../mocks/mockModel';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';
import operationSignatures from '../_constants/operationSignatures.json';

function pageRenderer(props) {
  return <PageRendererComponent {...props} />;
}
//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const brandsSpecificData = async () => {
  const { NEXT_PUBLIC_SUBMIT_SEARCH_URL, NEXT_PUBLIC_AVAILABILITY_SEARCH_URL, GOOGLE_MAP_API_KEY } = getProcessEnvs();
  // Feature flag call for logo
  const featureFlagLogo = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION, {
    target: TARGETS.APP.BRANDS_RENDERER,
  });
  return {
    operationSignatures,
    productSpecificResponse: [],
    NEXT_PUBLIC_SUBMIT_SEARCH_URL,
    NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
    GOOGLE_MAP_API_KEY,
    featureFlagLogo,
  };
};
//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerSideProps: GetServerSideProps<any> = prePageCall(brandsSpecificData, mockModel);
export default pageRenderer;
